import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';

import { saveRequest } from './store/actions/form';
import { canSave, getPaths } from './store/selectors';

export function NewImportCancelModal({
  canSave,
  onSubmit,
  paths
}) {
  const [showCancelModal, setShowCancelModal] = useState(false);

  const handleSubmit = () => {
    onSubmit()
      .then((response) => {
        if (response) {
          window.location = paths.databaseSettings;
        }
      });
  };

  const onCancel = (e) => {
    e.stopPropagation();
    if (canSave) {
      setShowCancelModal(true);
    } else {
      window.location = paths.databaseSettings;
    }
  };

  const handleQuit = () => {
    window.location = paths.databaseSettings;
  };

  const handleHide = () => {
    setShowCancelModal(false);
  };

  return (
    <React.Fragment>
      <Modal show={showCancelModal} onHide={handleHide}>
        <Modal.Header closeButton>
          <Modal.Title>Unsaved changes</Modal.Title>
        </Modal.Header>
        <Modal.Body className="left-buffer-md">
          <div className="top-buffer-sm">Would you like to save your import progress before quitting?</div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-sm btn-cancel" name="handleQuit" type="button" onClick={handleQuit}>
            Quit without saving
          </button>
          <button className="btn btn-sm btn-save" type="button" onClick={handleSubmit}>Save &amp; Quit</button>
        </Modal.Footer>
      </Modal>
      <button className="btn btn-cancel" name="cancel" type="button" onClick={onCancel}>Cancel</button>
    </React.Fragment>
  );
}

NewImportCancelModal.propTypes = {
  canSave: PropTypes.bool,
  paths: PropTypes.shape({
    createRequest: PropTypes.string.isRequired,
    databaseSettings: PropTypes.string.isRequired
  }).isRequired,
  onSubmit: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  canSave: canSave(state),
  paths: getPaths(state)
});

const mapDispatchToProps = {
  onSubmit: saveRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(NewImportCancelModal);
